module.exports = __webpack_public_path__ + "img/icomoon.7083b8c4.svg";